module.exports = __webpack_public_path__ + "static/img/02.ad119c05.jpg";